export { default as F } from './F';
export { default as T } from './T';
export { default as __ } from './__';
export { default as add } from './add';
export { default as addIndex } from './addIndex';
export { default as adjust } from './adjust';
export { default as all } from './all';
export { default as allPass } from './allPass';
export { default as always } from './always';
export { default as and } from './and';
export { default as any } from './any';
export { default as anyPass } from './anyPass';
export { default as ap } from './ap';
export { default as aperture } from './aperture';
export { default as append } from './append';
export { default as apply } from './apply';
export { default as applySpec } from './applySpec';
export { default as applyTo } from './applyTo';
export { default as ascend } from './ascend';
export { default as assoc } from './assoc';
export { default as assocPath } from './assocPath';
export { default as binary } from './binary';
export { default as bind } from './bind';
export { default as both } from './both';
export { default as call } from './call';
export { default as chain } from './chain';
export { default as clamp } from './clamp';
export { default as clone } from './clone';
export { default as comparator } from './comparator';
export { default as complement } from './complement';
export { default as compose } from './compose';
export { default as composeK } from './composeK';
export { default as composeP } from './composeP';
export { default as concat } from './concat';
export { default as cond } from './cond';
export { default as construct } from './construct';
export { default as constructN } from './constructN';
export { default as contains } from './contains';
export { default as converge } from './converge';
export { default as countBy } from './countBy';
export { default as curry } from './curry';
export { default as curryN } from './curryN';
export { default as dec } from './dec';
export { default as defaultTo } from './defaultTo';
export { default as descend } from './descend';
export { default as difference } from './difference';
export { default as differenceWith } from './differenceWith';
export { default as dissoc } from './dissoc';
export { default as dissocPath } from './dissocPath';
export { default as divide } from './divide';
export { default as drop } from './drop';
export { default as dropLast } from './dropLast';
export { default as dropLastWhile } from './dropLastWhile';
export { default as dropRepeats } from './dropRepeats';
export { default as dropRepeatsWith } from './dropRepeatsWith';
export { default as dropWhile } from './dropWhile';
export { default as either } from './either';
export { default as empty } from './empty';
export { default as endsWith } from './endsWith';
export { default as eqBy } from './eqBy';
export { default as eqProps } from './eqProps';
export { default as equals } from './equals';
export { default as evolve } from './evolve';
export { default as filter } from './filter';
export { default as find } from './find';
export { default as findIndex } from './findIndex';
export { default as findLast } from './findLast';
export { default as findLastIndex } from './findLastIndex';
export { default as flatten } from './flatten';
export { default as flip } from './flip';
export { default as forEach } from './forEach';
export { default as forEachObjIndexed } from './forEachObjIndexed';
export { default as fromPairs } from './fromPairs';
export { default as groupBy } from './groupBy';
export { default as groupWith } from './groupWith';
export { default as gt } from './gt';
export { default as gte } from './gte';
export { default as has } from './has';
export { default as hasIn } from './hasIn';
export { default as head } from './head';
export { default as identical } from './identical';
export { default as identity } from './identity';
export { default as ifElse } from './ifElse';
export { default as inc } from './inc';
export { default as indexBy } from './indexBy';
export { default as indexOf } from './indexOf';
export { default as init } from './init';
export { default as innerJoin } from './innerJoin';
export { default as insert } from './insert';
export { default as insertAll } from './insertAll';
export { default as intersection } from './intersection';
export { default as intersperse } from './intersperse';
export { default as into } from './into';
export { default as invert } from './invert';
export { default as invertObj } from './invertObj';
export { default as invoker } from './invoker';
export { default as is } from './is';
export { default as isEmpty } from './isEmpty';
export { default as isNil } from './isNil';
export { default as join } from './join';
export { default as juxt } from './juxt';
export { default as keys } from './keys';
export { default as keysIn } from './keysIn';
export { default as last } from './last';
export { default as lastIndexOf } from './lastIndexOf';
export { default as length } from './length';
export { default as lens } from './lens';
export { default as lensIndex } from './lensIndex';
export { default as lensPath } from './lensPath';
export { default as lensProp } from './lensProp';
export { default as lift } from './lift';
export { default as liftN } from './liftN';
export { default as lt } from './lt';
export { default as lte } from './lte';
export { default as map } from './map';
export { default as mapAccum } from './mapAccum';
export { default as mapAccumRight } from './mapAccumRight';
export { default as mapObjIndexed } from './mapObjIndexed';
export { default as match } from './match';
export { default as mathMod } from './mathMod';
export { default as max } from './max';
export { default as maxBy } from './maxBy';
export { default as mean } from './mean';
export { default as median } from './median';
export { default as memoize } from './memoize';
export { default as memoizeWith } from './memoizeWith';
export { default as merge } from './merge';
export { default as mergeAll } from './mergeAll';
export { default as mergeDeepLeft } from './mergeDeepLeft';
export { default as mergeDeepRight } from './mergeDeepRight';
export { default as mergeDeepWith } from './mergeDeepWith';
export { default as mergeDeepWithKey } from './mergeDeepWithKey';
export { default as mergeWith } from './mergeWith';
export { default as mergeWithKey } from './mergeWithKey';
export { default as min } from './min';
export { default as minBy } from './minBy';
export { default as modulo } from './modulo';
export { default as multiply } from './multiply';
export { default as nAry } from './nAry';
export { default as negate } from './negate';
export { default as none } from './none';
export { default as not } from './not';
export { default as nth } from './nth';
export { default as nthArg } from './nthArg';
export { default as o } from './o';
export { default as objOf } from './objOf';
export { default as of } from './of';
export { default as omit } from './omit';
export { default as once } from './once';
export { default as or } from './or';
export { default as over } from './over';
export { default as pair } from './pair';
export { default as partial } from './partial';
export { default as partialRight } from './partialRight';
export { default as partition } from './partition';
export { default as path } from './path';
export { default as pathEq } from './pathEq';
export { default as pathOr } from './pathOr';
export { default as pathSatisfies } from './pathSatisfies';
export { default as pick } from './pick';
export { default as pickAll } from './pickAll';
export { default as pickBy } from './pickBy';
export { default as pipe } from './pipe';
export { default as pipeK } from './pipeK';
export { default as pipeP } from './pipeP';
export { default as pluck } from './pluck';
export { default as prepend } from './prepend';
export { default as product } from './product';
export { default as project } from './project';
export { default as prop } from './prop';
export { default as propEq } from './propEq';
export { default as propIs } from './propIs';
export { default as propOr } from './propOr';
export { default as propSatisfies } from './propSatisfies';
export { default as props } from './props';
export { default as range } from './range';
export { default as reduce } from './reduce';
export { default as reduceBy } from './reduceBy';
export { default as reduceRight } from './reduceRight';
export { default as reduceWhile } from './reduceWhile';
export { default as reduced } from './reduced';
export { default as reject } from './reject';
export { default as remove } from './remove';
export { default as repeat } from './repeat';
export { default as replace } from './replace';
export { default as reverse } from './reverse';
export { default as scan } from './scan';
export { default as sequence } from './sequence';
export { default as set } from './set';
export { default as slice } from './slice';
export { default as sort } from './sort';
export { default as sortBy } from './sortBy';
export { default as sortWith } from './sortWith';
export { default as split } from './split';
export { default as splitAt } from './splitAt';
export { default as splitEvery } from './splitEvery';
export { default as splitWhen } from './splitWhen';
export { default as startsWith } from './startsWith';
export { default as subtract } from './subtract';
export { default as sum } from './sum';
export { default as symmetricDifference } from './symmetricDifference';
export { default as symmetricDifferenceWith } from './symmetricDifferenceWith';
export { default as tail } from './tail';
export { default as take } from './take';
export { default as takeLast } from './takeLast';
export { default as takeLastWhile } from './takeLastWhile';
export { default as takeWhile } from './takeWhile';
export { default as tap } from './tap';
export { default as test } from './test';
export { default as times } from './times';
export { default as toLower } from './toLower';
export { default as toPairs } from './toPairs';
export { default as toPairsIn } from './toPairsIn';
export { default as toString } from './toString';
export { default as toUpper } from './toUpper';
export { default as transduce } from './transduce';
export { default as transpose } from './transpose';
export { default as traverse } from './traverse';
export { default as trim } from './trim';
export { default as tryCatch } from './tryCatch';
export { default as type } from './type';
export { default as unapply } from './unapply';
export { default as unary } from './unary';
export { default as uncurryN } from './uncurryN';
export { default as unfold } from './unfold';
export { default as union } from './union';
export { default as unionWith } from './unionWith';
export { default as uniq } from './uniq';
export { default as uniqBy } from './uniqBy';
export { default as uniqWith } from './uniqWith';
export { default as unless } from './unless';
export { default as unnest } from './unnest';
export { default as until } from './until';
export { default as update } from './update';
export { default as useWith } from './useWith';
export { default as values } from './values';
export { default as valuesIn } from './valuesIn';
export { default as view } from './view';
export { default as when } from './when';
export { default as where } from './where';
export { default as whereEq } from './whereEq';
export { default as without } from './without';
export { default as xprod } from './xprod';
export { default as zip } from './zip';
export { default as zipObj } from './zipObj';
export { default as zipWith } from './zipWith';


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/index.js
// module id = ../node_modules/ramda/es/index.js
// module chunks = 5